import { Checkbox, Form } from 'antd';
import { useContext, useRef } from 'react';
import { useStore } from 'zustand';

import { inventoryStore } from 'app/components/pages/Extranet/ExtranetInventory/Modern/InventoryStore';
import { ConstantValueInput } from 'app/components/pages/Extranet/ExtranetInventory/Modern/_components/Common/ConstantValueInput/ConstantValueInput';
import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';

import styles from './ConstantStock.module.scss';

const STOCK_FIELD = [
  'openingConfiguration',
  'stockConfiguration',
  'configuration',
  'stock',
];

export const ConstantStock = () => {
  const { getExperience } = useContext(ModernHotelContext);
  const experienceId = useStore(
    inventoryStore,
    (state) => state.experienceStockConfig?.expId
  );

  const experience = getExperience(experienceId);

  const inputRef = useRef<HTMLInputElement>(null);
  const form = Form.useFormInstance();
  const stockValue = Form.useWatch(STOCK_FIELD, form);

  const isUnlimited = stockValue === null;

  const handleUnlimitedChange = (checked: boolean) => {
    if (checked) {
      form.setFieldValue(STOCK_FIELD, null);
    } else {
      form.setFieldValue(STOCK_FIELD, 0);
      requestAnimationFrame(() => {
        inputRef.current?.focus();
      });
    }
  };

  const isAlwaysIncludedWithNight = experience?.isAlwaysIncludedWithNight;

  return (
    <div className={styles.stockContent}>
      {!isAlwaysIncludedWithNight && (
        <ConstantValueInput
          name={STOCK_FIELD}
          label="Publish"
          suffix="stocks every day"
          inputRef={inputRef}
          placeholder="∞"
          isRequired={false}
        />
      )}
      <div className={styles.checkboxWrapper}>
        <div className={styles.checkboxRow}>
          {!isAlwaysIncludedWithNight && (
            <Checkbox
              checked={isUnlimited}
              onChange={(e) => handleUnlimitedChange(e.target.checked)}
            />
          )}
          <p className={styles.checkboxLabel}>
            Unlimited (∞) {isAlwaysIncludedWithNight ? 'stock per day' : ''}
          </p>
        </div>
        {!isAlwaysIncludedWithNight && (
          <p className={styles.description}>
            The activity is usually not limited by capacity constraints.
          </p>
        )}
      </div>
    </div>
  );
};
